import type { ComponentPropsWithoutRef } from 'react'

import cn from '@components/utils/cn'

export function Avatar({
  name,
  muted = false,
  className,
  ...rest
}: { name: string; muted?: boolean } & ComponentPropsWithoutRef<'span'>) {
  const initials =
    name
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase())
      .join('') || '?'

  return (
    <span
      aria-hidden
      {...rest}
      className={cn(
        'tw:flex tw:h-6 tw:w-6 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:text-xs tw:font-semibold',
        muted ? 'tw:bg-gray-200 tw:text-gray-500' : 'tw:bg-primary-100 tw:text-primary-700',
        className
      )}
    >
      {initials}
    </span>
  )
}
